<template>
    <div>
        <div>
            筛选：
            <el-select v-model="value">
                <el-option
                        v-for="item of options"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"/>
            </el-select>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="[]"
                    row-key="id"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" align="center"/>
                <el-table-column label="用户账号" align="center"/>
                <el-table-column label="处理对象" align="center"/>
                <el-table-column label="对象身份" align="center"/>
                <el-table-column label="联系方式" align="center"/>
                <el-table-column label="账号身份" align="center"/>
                <el-table-column label="处理结果" align="center"/>
                <el-table-column label="时间" align="center"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="0"
                :current-page="1"
                @current-change="()=>({})"/>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                value: '',
                options: [
                    {label: '全部', value: ''},
                    {label: '俱乐部', value: '1'},
                    {label: '联盟', value: '2'}
                ]
            }
        }
    }
</script>